module.exports = __webpack_public_path__ + "40b9db46.svg";